import Footer from "../../components/VibrantSolComponents/Footer";
import Header from "../../components/VibrantSolComponents/Header";
import bannerimg from "../../banner-35.jpg";
import { Button } from "../../components/ui/button";
import { Textarea } from "../../components/ui/textarea";
import React, { useState } from "react";
function BlogDetails() {
  const [selected, setSelected] = useState(null);
  const [note, setNote] = useState("");

  const handleEmojiClick = (idx) => setSelected(idx);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Feedback:", emojiList[selected].label, "Notes:", note);
    setSelected(null);
    setNote("");
    alert("Thank you for your feedback!");
  };
  const emojiList = [
    {
      label: "Very Sad",
      icon: (
        <svg key="very-sad" className="w-14 h-14" viewBox="0 0 48 48">
          <circle cx="24" cy="24" r="22" fill="#FFEB3B" />
          <circle cx="16" cy="20" r="3" fill="#000" />
          <circle cx="32" cy="20" r="3" fill="#000" />
          <path
            d="M16 34c2-2 6-2 8-2s6 0 8 2"
            stroke="#000"
            strokeWidth="2"
            fill="none"
          />
          <line x1="16" y1="20" x2="18" y2="22" stroke="#fff" strokeWidth="2" />
          <line x1="32" y1="20" x2="30" y2="22" stroke="#fff" strokeWidth="2" />
          <circle cx="16" cy="20" r="1" fill="#fff" />
          <circle cx="32" cy="20" r="1" fill="#fff" />
          <path d="M19 16l1 1M29 16l-1 1" stroke="#000" strokeWidth="2" />
        </svg>
      ),
    },
    {
      label: "Sad",
      icon: (
        <svg key="sad" className="w-14 h-14" viewBox="0 0 48 48">
          <circle cx="24" cy="24" r="22" fill="#FFEB3B" />
          <circle cx="16" cy="20" r="3" fill="#000" />
          <circle cx="32" cy="20" r="3" fill="#000" />
          <path
            d="M16 34c4-4 12-4 16 0"
            stroke="#000"
            strokeWidth="2"
            fill="none"
          />
          <circle cx="20" cy="28" r="1" fill="#fff" />
          <circle cx="28" cy="28" r="1" fill="#fff" />
        </svg>
      ),
    },
    {
      label: "Neutral",
      icon: (
        <svg key="neutral" className="w-14 h-14" viewBox="0 0 48 48">
          <circle cx="24" cy="24" r="22" fill="#FFEB3B" />
          <circle cx="16" cy="20" r="3" fill="#000" />
          <circle cx="32" cy="20" r="3" fill="#000" />
          <line x1="16" y1="34" x2="32" y2="34" stroke="#000" strokeWidth="2" />
        </svg>
      ),
    },
    {
      label: "Happy",
      icon: (
        <svg key="happy" className="w-14 h-14" viewBox="0 0 48 48">
          <circle cx="24" cy="24" r="22" fill="#FFEB3B" />
          <circle cx="16" cy="20" r="3" fill="#000" />
          <circle cx="32" cy="20" r="3" fill="#000" />
          <path
            d="M16 32c2 4 12 4 16 0"
            stroke="#000"
            strokeWidth="2"
            fill="none"
          />
        </svg>
      ),
    },
    {
      label: "Very Happy",
      icon: (
        <svg key="very-happy" className="w-14 h-14" viewBox="0 0 48 48">
          <circle cx="24" cy="24" r="22" fill="#FFEB3B" />
          <circle cx="16" cy="20" r="3" fill="#000" />
          <circle cx="32" cy="20" r="3" fill="#000" />
          <path
            d="M16 30c2 6 12 6 16 0"
            stroke="#000"
            strokeWidth="2"
            fill="#fff"
          />
          <rect x="21" y="32" width="6" height="2" fill="#000" />
          <rect x="18" y="28" width="12" height="4" rx="2" fill="#fff" />
        </svg>
      ),
    },
  ];
  return (
    <>
      <div className="min-h-screen">
        <Header />
        <nav className="flex justify-center py-4 bg-gray-50">
          <ol className="flex items-center space-x-2">
            <li>
              <span className="text-gray-400 font-medium">Home</span>
            </li>
            <li>
              <span className="text-gray-300 font-medium">——</span>
            </li>
            <li>
              <span className="text-gray-700 font-medium">Blogs</span>
            </li>
          </ol>
        </nav>
        <div className="max-w-5xl mx-auto px-4 py-12 blogdetails">
          <h1 className="text-4xl md:text-5xl text-center mb-6">
            Are You Washing Your Face Properly?
          </h1>
          {/* Author + Meta */}
          <div className="flex justify-center items-center gap-1.5 mb-8 text-gray-500 text-sm">
            <span>Jan 19, 2021</span>
            <span className="mx-2">|</span>
            <span>134 views</span>
          </div>
          {/* Main content */}
          <div className="space-y-6">
            <p className="text-lg font-medium text-center text-black">
              We do good to the planet while delivering smiles to your loved
              ones. We believe even the smallest choices we make can have a
              significant impact over time. That’s why it’s our goal to make
              eco-friendly alternatives more accessible than ever.
            </p>
            <p className="text-gray-500 text-base leading-relaxed text-center">
              Awkwardness gives me great comfort. I’ve never been cool, but I’ve
              felt cool. I’ve been in the cool place, but I wasn’t really cool –
              I was trying to pass for hip or cool. It’s the awkwardness that’s
              nice. We look our best in subdued colors, sophisticated cuts, and
              a general air of sleek understatement. I like the body. I like to
              design everything to do with the body.
            </p>
            <p className="text-gray-500 text-base">
              If I fell in love with a woman for an artistic reason, or from the
              point of view of my work, I think it would rob her of something.
              We live in an era of globalization and the era of the woman. Never
              in the history of the world have women been more in control of
              their destiny.
            </p>
            <div className="rounded-lg overflow-hidden shadow mb-16">
              <img
                src={bannerimg}
                alt="Health Banner"
                className="w-full object-cover"
                loading="lazy"
              />
            </div>
            <h2 className="text-lg font-semibold mt-5 mb-1">
              Your imagination, our creation
            </h2>

            <p className="text-gray-500 text-base">
              Complexion-perfecting natural foundation enriched with
              antioxidant-packed superfruits, vitamins, and other
              skin-nourishing nutrients. Creamy liquid formula sets with a
              pristine matte finish for soft, velvety smooth skin. Made using
              clean, non-toxic ingredients, our products are designed for
              everyone...
            </p>
            <p className="text-gray-500 text-base">
              Complexion-perfecting natural foundation enriched with
              antioxidant-packed superfruits, vitamins, and other
              skin-nourishing nutrients. Creamy liquid formula sets with a
              pristine matte finish for soft, velvety smooth skin. Made using
              clean, non-toxic ingredients, our products are designed for
              everyone...
            </p>
            <p className="text-gray-500 text-base">
              If I fell in love with a woman for an artistic reason, or from the
              point of view of my work, I think it would rob her of something.
              We live in an era of globalization and the era of the woman. Never
              in the history of the world have women been more in control of
              their destiny.
            </p>
            <div className="mt-12 flex flex-col items-center">
              <h3 className="text-xl font-medium mb-4">
                Was this Article helpful?
              </h3>
              <div className="flex gap-6 mb-4">
                {emojiList.map((emoji, idx) => (
                  <button
                    key={idx}
                    type="button"
                    className={`w-16 h-16 rounded-full flex items-center justify-center transition-transform hover:scale-110 focus:outline-none ${
                      selected === idx ? "ring-4 ring-yellow-300" : ""
                    }`}
                    onClick={() => handleEmojiClick(idx)}
                    aria-label={emoji.label}
                  >
                    <span>{emoji.icon}</span>
                  </button>
                ))}
              </div>
              {selected !== null && (
                <form
                  onSubmit={handleSubmit}
                  className="w-full max-w-md flex flex-col items-center"
                >
                  <label
                    htmlFor="feedbackNotes"
                    className="block text-base font-medium mb-2 text-gray-800"
                  >
                    Notes/Suggestions
                  </label>
                  <Textarea
                    id="feedbackNotes"
                    rows={3}
                    placeholder="Share your thoughts..."
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    required
                    className="mb-3"
                  />
                  <Button
                    type="submit"
                    className="bg-primary text-white py-6 px-10 rounded-md font-semibold hover:bg-gray-800 transition"
                  >
                    Submit
                  </Button>
                </form>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
export default BlogDetails;
